import React, { useEffect, useState, useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Checkbox, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import axios from 'axios'
import Pagination from "react-js-pagination";
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import MemberConfigList from '../../../components/MemberConfigList';
import { MdOutlineRefresh } from "react-icons/md";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

const useStyles = makeStyles((theme)=>({
  box: {
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px 20px 20px',
  },
  box2: {
  },
  h1SearchDiv:{
    padding:'40px 0px',
    display:'flex',
    flexDirection:'column',
  },
  contConfigBlockH1:{
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  head: {
    borderTop: '1px solid #D3D3D3',
    borderBottom: '1px solid #D3D3D3',
    display: 'flex',

    [theme.breakpoints.down(1025)]: {
      display:'none'
    } 
  },
  mobilehead:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',
      borderTop: '1px solid #D3D3D3',
      borderBottom: '1px solid #D3D3D3',
      display: 'flex',
    } 
  },
  checkBox: {
    borderRight: '1px solid #D3D3D3',
    width: '8%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down(1025)]: {
      
    } 
  },
  oneBox: {
    borderRight: '1px solid #D3D3D3',
    width: '10%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      width: '46%',
    } 
  },
  twoBox: {
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    flexDirection: 'column',
    width: '10%',
    wordBreak:'break-all',
  },
  threeBox: {
    borderRight: '1px solid #D3D3D3',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '10%',
    wordBreak:'break-all',
  },
  inBox1: {
    borderBottom:'1px solid #D3D3D3',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inBox2: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
      minWidth: '30px',
      border: '1px solid #e2e2e2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
  },
  itemClassFirst: {
      borderRadius: '15px 0 0 15px',
  },
  itemClassLast: {
      borderRadius: '0 15px 15px 0',
  },
  linkClass: {
      textDecoration: 'none',
      color: '#383A3F',
      fontSize: '1rem',
  },
  activeClass: {
      backgroundColor: '#383A3F'
  },
  activeLinkClass: {
      color: 'white',
  },

  itemBox: {
    borderBottom: '1px solid #D3D3D3',
    display: 'flex',

    [theme.breakpoints.down(1025)]: {
      display:'none'
    } 
  },
  mobileItemBox:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',
      borderBottom: '1px solid #D3D3D3',
      display: 'flex',
    } 
  },
  btnDivTop:{
    display:'flex',
    marginBottom:'10px',
    justifyContent:'space-between',
  },
  btnDivTopRight:{
    display:'flex',
    justifyContent:'end',
  },
  btnDivTopLeft:{
    
  },
  btnDiv:{
    display:'flex',
    justifyContent:'end',
    marginTop:'30px'
  },
  btnButton:{
    margin:'0 0 0 40px'
  },
  bottomDiv:{
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'flex-start',
    } 
  },
  formBox:{
    margin:'20px 10px'
  },
  RightDiv:{
    margin:'0 0 0 20px',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      margin:'0',
    } 
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  navibox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center'
  },
  naviArrow: {
    marginTop: 13,
    cursor: 'pointer',
    border: '1px solid gray',
    padding: 5
  }

}));

const MemberConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [page, setPage] = useState(1);
  const [pasings, setPasings] = useState(0);
  const [data, setData] = useState([])

  const [picList, setPicList] = useState([]) 

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [searchType, setSearchType] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [search, setSearch] = useState(false);

  const [loading, setLoading] = useState(false)

  const [delDial, setDelDial] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setData([])
      setChecks([])
      setAllChecked(false)
      setPage(1)
      setPasings(0)
      setPicList([])
      setSearchType(0)
      setKeyword('')
    }
  }, [])

  const getMemberItems = useCallback(async() => {
    
    try {
      setLoading(true)
      const res = await axios.get(`/api/adm/MemberConfig/${page}/`)

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setData(res.data.result)
      setPicList(res.data.picList)
      setPasings(res.data.itemCount)
      setLoading(false)
      
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
    
  }, [page])



  const searchItem = useCallback(async() => {
    
    setSearch(true)

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/memberSearch/', {page: page, search_type: searchType, keyword: keyword} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setChecks([])
      setAllChecked(false)
      setData(res.data.result)
      setPasings(res.data.itemCount)
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }

    if (keyword === ''){
      setSearch(false)
    }

  }, [page, searchType, keyword])


  useEffect(() => {

    if(search) {
      searchItem()
    } else{
      getMemberItems()
    }
    setChecks([])
    setAllChecked(false)
    
  }, [page])


  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item['mb_no']));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])

  const handlePageChange = (page) => {
    setPage(page);
  };



  const editSelItems = useCallback(async() => {
    let mbList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem['mb_no'] === arrItem){
          mbList.push({
            mb_no: dataItem['mb_no'],
            mb_mailling: dataItem['mb_mailling'],
            mb_sms: dataItem['mb_sms'],
            mb_level: dataItem['mb_level'],
            mb_region: dataItem['mb_region'],
            mb_storename: dataItem['mb_storename'],
            pic_id: dataItem['pic_id']
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/memberSelectEdit/', {mb_list: mbList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return;
      }
      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      getMemberItems()
      
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }, [checks, data])


  const delSelItems = useCallback(async() => {
    let mbList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem['mb_no'] === arrItem){
          mbList.push({
            mb_no: dataItem['mb_no']
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/memberSelectDelete/', {mb_list: mbList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return;
      }
      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      setDelDial(false)
      getMemberItems()
      
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }, [checks, data])



  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return (
    <div className={classes.memberConfigBlock}>
      <div className={classes.box}>
        <div className={classes.h1SearchDiv}>
          <h1 className={classes.contConfigBlockH1}>
            회원관리
            <div
              onClick={() => {
                setData([])
                setPage(1)
                setSearch(false)
                setSearchType(0)
                setKeyword('')
                getMemberItems()
              }}
            style={{cursor:'pointer'}}
          >
            <MdOutlineRefresh/>
          </div>
          </h1>
          <div className={classes.bottomDiv}>
                <FormControl 
                  style={{ width:'130px', margin:'20px 0'}}
                  className={ classes.formBox}
                >
                  <Select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem value={0}>아이디</MenuItem>
                    <MenuItem value={1}>닉네임</MenuItem>
                    <MenuItem value={2}>이름</MenuItem>
                    <MenuItem value={3}>권한</MenuItem>
                    <MenuItem value={4}>EMAIL</MenuItem>
                    <MenuItem value={5}>전화번호</MenuItem>
                    <MenuItem value={6}>휴대폰번호</MenuItem>
                    <MenuItem value={7}>포인트</MenuItem>
                    <MenuItem value={8}>가입일시</MenuItem>
                    <MenuItem value={9}>IP</MenuItem>
                  </Select>
                </FormControl>
              <div className={ classes.RightDiv}>
                <TextField 
                  label="검색어를 입력해주세요." 
                  variant="standard" 
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if(e.key === 'Enter') {
                      setPage(1)
                      searchItem()
                    }
                  }}
                />
                <Button 
                  variant="outlined"
                  onClick={() => {
                    setPage(1)
                    searchItem()
                  }}
                >
                  검색
                </Button>
              </div>
            </div>
        </div>

          <div className={classes.btnDivTop}>
            <div className={classes.btnDivTopLeft}>
              <Button 
                variant="outlined"
                onClick={() => {
                  navigate("/DashboardMain/memberAdd");
                }}
                style={{ margin:'0 0 20px 0px'}}
              >
                회원추가
              </Button>
            </div>
            <div className={classes. btnDivTopRight}>
              <div>
                <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>선택수정</Button>
              </div>
              <div className={classes.btnButton}>
                <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>선택삭제</Button>
              </div>
        </div>
          </div>
        <div className={classes.datagridBox}>
          <div className={classes.head}>  
            <div className={classes.checkBox}>
              <Checkbox 
                  checked={allChecked}
                  onChange={e => setAllChecked(e.target.checked)}
              />
            </div>
  
            <div className={classes.oneBox}>
              아이디
            </div>
  
            <div className={classes.twoBox}>
              <div className={classes.inBox1}>
                이름
              </div>
              <div className={classes.inBox2}>
                닉네임
              </div>
            </div>
  
            <div className={classes.threeBox}>
              메일수신
            </div>
  
            <div className={classes.threeBox}>
              SMS수신
            </div>
  
            <div className={classes.twoBox}>
              <div className={classes.inBox1}>
                휴대폰
              </div>
              <div className={classes.inBox2}>
                전화번호
              </div>
            </div>
  
            <div className={classes.twoBox}>
              <div className={classes.inBox1}>
                상태/권한
              </div>
              <div className={classes.inBox2}>
                포인트
              </div>
            </div>
  
            <div className={classes.twoBox}>
              <div className={classes.inBox1}>
                최종접속
              </div>
              <div className={classes.inBox2}>
                가입일
              </div>
            </div>
  
            <div className={classes.oneBox}>
              지역
            </div>
  
            <div className={classes.oneBox}>
              상호명
            </div>
  
            <div className={classes.oneBox}>
              담당자명
            </div>
  
            <div className={classes.oneBox}>
              관리
            </div>
  
          </div>

          <div className={classes.mobilehead}>  
            <div className={classes.checkBox}>
              <Checkbox 
                  checked={allChecked}
                  onChange={e => setAllChecked(e.target.checked)}
              />
            </div>
  
            <div className={classes.oneBox}>
              아이디
            </div>

            <div className={classes.oneBox}>
              관리
            </div> 
          </div>
  
          {loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
          ) :
          (data.length > 0 && picList.length > 0) && 
            <MemberConfigList 
              checks={checks}
              setChecks={setChecks}
              data={data}
              setData={setData}
              picList={picList}
            />
          }
        </div>
  
        <div className={classes.navibox}>
          <AiOutlineDoubleLeft 
            onClick={() => setPage(1)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineLeft 
            onClick={() => setPage(page-5 <= 0 ? 1 : page-5)}
            className={classes.naviArrow}
            size="24"
          />
          <Pagination
              activePage={page}
              itemsCountPerPage={15}
              totalItemsCount={pasings}
              pageRangeDisplayed={5}
              prevPageText={"‹"}
              nextPageText={"›"}
              onChange={handlePageChange}
              className={classes.navi}
              innerClass={classes.innerClass}    //안에?
              itemClass={classes.itemClass}      //아이템들?
              itemClassFirst={classes.itemClassFirst}    //first?
              itemClassLast={classes.itemClassLast}     // last
              linkClass={classes.linkClass}        // 아이템 링크
              activeClass={classes.activeClass}        // 현재페이지
              activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
              hideDisabled
              hideNavigation
              hideFirstLastPages
          />
          <AiOutlineRight 
            onClick={() => setPage(page+5 > Math.ceil(pasings/15) ? Math.ceil(pasings/15) : page+5)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineDoubleRight 
            onClick={() => setPage(Math.ceil(pasings/15))}
            className={classes.naviArrow}
            size="24"
          />
        </div>
  
  
        <div className={classes.btnDiv}>
          <div>
            <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>선택수정</Button>
          </div>
          <div className={classes.btnButton}>
            <Button variant="outlined" onClick={() => checks.length > 0 && setDelDial(true)}>선택삭제</Button>
          </div>
        </div>    
  
  
        
  
        <Snackbar 
          open={errSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="error">수행을 실패 하였습니다!</Alert>
        </Snackbar>
        <Snackbar 
          open={succSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="success">수행을 성공 하였습니다!</Alert>
        </Snackbar> 
        
        <Dialog
          open={delDial}
          onClose={() => setDelDial(false)}
        >
          <DialogContent>
            <DialogContentText>
              정말 삭제 하시겠습니까?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDelDial(false)}>아니오</Button>
            <Button onClick={() => delSelItems()}>네</Button>
          </DialogActions>
        </Dialog>
  
      </div>
    </div>
  )
}




export default MemberConfig
